import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTOS]: {
		url:'/company/:companyId/done_works/:doneWorkId/photos/'
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTO_PREVIEW]: {
		url: '/company/:companyId/done_works/:doneWorkId/photos/:photoId/preview/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTO_POPUP]: {
		url: '/company/:companyId/done_works/:doneWorkId/photos/:photoId/popup/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTO]: {
		url: '/company/:companyId/done_works/:doneWorkId/photos/:photoId/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].CREATE_DONE_WORKS_PHOTO]: {
		url:'/company/:companyId/done_works/:doneWorkId/photos/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].PATCH_DONE_WORKS_PHOTO]: {
		url: '/company/:companyId/done_works/:doneWorkId/photos/:photoId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].PUT_DONE_WORKS_PHOTO]: {
		url: '/company/:companyId/done_works/:doneWorkId/photos/:photoId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].DELETE_DONE_WORKS_PHOTO]: {
		url: '/company/:companyId/done_works/:doneWorkId/photos/:photoId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}